import { render, staticRenderFns } from "./WhiteBox.vue?vue&type=template&id=464cbc24&scoped=true&"
import script from "./WhiteBox.vue?vue&type=script&lang=js&"
export * from "./WhiteBox.vue?vue&type=script&lang=js&"
import style0 from "./WhiteBox.vue?vue&type=style&index=0&id=464cbc24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464cbc24",
  null
  
)

export default component.exports